import { render, staticRenderFns } from "./TwentyTwoTable.vue?vue&type=template&id=04e88fa4&"
import script from "./TwentyTwoTable.vue?vue&type=script&lang=js&"
export * from "./TwentyTwoTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports